<template>
    <footer class="footer">
        <b-container fluid>
            <b-row>
                <b-col col sm="6">
                    2024 - {{ new Date().getFullYear() }} © InMotion.
                </b-col>
                <b-col col sm="6">
                    <div class="text-sm-end d-none d-sm-block">
                        Design & Develop with ❤️ by me.
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </footer>
</template>
